import sdkProvider from "../../../../client/sdkProvider";
import setLoyaltyMembersDaySaleEvent from "./setLoyaltyMembersDaySaleEvent";
import logger from "../../../../lib/logger";
import getActiveMembersDaySaleEvent from "../selectors/getActiveMembersDaySaleEvent";

const loadLoyaltyGetActiveMembersDaySaleEvent = () => async dispatch => {
  try {
    const loyaltySdk = await sdkProvider("loyalty");
    const config = await loyaltySdk.getConfig();

    const benefits = config?.benefits;
    if (!benefits) {
      dispatch(setLoyaltyMembersDaySaleEvent(null));
    }

    dispatch(
      setLoyaltyMembersDaySaleEvent(getActiveMembersDaySaleEvent(config))
    );
  } catch (error) {
    if (error.name !== "LoyaltyNotSupportedError") {
      error.message = `loadLoyaltyGetActiveMembersDaySaleEvent failed with error: ${error.message}`;
      logger.error(error);
    }
  }
};

export default loadLoyaltyGetActiveMembersDaySaleEvent;
